export default __webpack_public_path__ + "static/media/YANDEX.449c46fa.png";